import React from 'react'
import { useGLTF } from '@react-three/drei'

function IndoorPlant(props) {
    const { nodes } = useGLTF('/3d_objects/SmallIndoorPlant.glb')
  
    React.useEffect(() => {
      props.setLoading(props.loading + 1)
    }, [nodes])
    
    return (
      <primitive
        object={nodes.PlantD}
        position={[-2.5, 3.315, -0.5]}
        scale={[2.5, 2.5, 2.5]}
        rotation={[0, Math.PI/4, 0]}
      />
    )
}

export default IndoorPlant;